import React,{Component} from 'react';

import imgFeature1 from '../assets/images/features/campaign.png'
import imgFeature2 from '../assets/images/features/task.png'
import imgFeature3 from '../assets/images/features/channel.png'
import imgFeature4 from '../assets/images/features/brief.png'
import imgFeature5 from '../assets/images/features/report.png'

import imgTab1 from '../assets/images/features/feature-1.campaign.jpeg'
import imgTab2 from '../assets/images/features/feature-2.task.jpeg'
import imgTab3 from '../assets/images/features/feature-3.filter.jpeg'
import imgTab4 from '../assets/images/features/feature-4.brief.jpeg'
import imgTab5 from '../assets/images/features/feature-5.analytic.jpeg'



export default class Feature extends Component{
    constructor(props){
        super(props)
        this.state = {
            features: [
                {
                    title: "Campaign Dashboard",
                    subTitle: "Manage campaign Anda dengan lebih terstruktur",
                    detail: <p> Ini merupakan pusat dari segala aktifitas Anda di SosiaGo Indonesia. Dimana Anda akan memulai promosi dengan membuat sebuah campaign baru sebelum memberikan pekerjaan ke influencer. Pembuatan campaign tidak ada batasan jumlah (unlimited) dan GRATIS selamanya. <br /><br />
                            Campaign dashboard memudahkan Anda untuk memanage sekaligus monitor aktifitas campaign yang Anda buat dengan penyajian data yang lengkap seperti jumlah task, spending budget yang telah digunakan serta hasil performance masing-masing campaign.
                            </p>,
                    img: imgTab1
                },
                {
                    title: "Task Monitoring",
                    subTitle: "Manage list pekerjaan yang sudah Anda lakukan",
                    detail: <p>Anda dapat melakukan pencarian sekaligus pemilihan channel-channel sosial media yang dimiliki Influencer untuk diberikan penugasan sponsored placement sesuai campaign yang Anda jalankan. Semua aktifitas influencer bisa Anda pantau disini.<br /><br />
                            Di dalam task monitoring ini Anda akan mendapatkan informasi dari masing-masing pekerjaan seperti brief yang sudah Anda berikan, status pekerjaan, laporan hasil placement, deadline timer (batas waktu) respon, dan performa impression dari pekerjaan yang telah di publish.                
                            </p>,
                    img: imgTab2
                },
                {
                    title: "Channel Filtering",
                    subTitle: "Filter pencarian channel Influencer sesuai kebutuhan",
                    detail: <p>Lakukan pencarian channel sosial media influencer dengan menggunakan fitur filtering yang kami miliki. Anda dapat dengan mudah menemukan dan membandingkan secara langsung list channel influencer yang bisa disesuaikan dengan kebutuhan campaign Anda.<br /><br />
                            Beberapa informasi filtering data yang kami berikan seperti harga per channel, kategori, lokasi, gender dan beberapa spesifik teknis masing-masing channel (domain authority, jumlah follower, dan pengunjung). Harga yang terlihat adalah sesuai biaya yang akan dibayar (no hidden fee).                 
                            </p>,
                    img: imgTab3
                },
                {
                    title: "Brief Discussion",
                    subTitle: "Diskusikan brief pekerjaan secara langsung",
                    detail: <p> Anda dapat berdiskusi secara langsung dengan Influencer untuk membahas atau menerima feedback dari brief yang telah Anda berikan termasuk melihat update laporan status pekerjaan yang telah dilakukan oleh masing-masing influencer. <br /><br />
                                Segala hal yang berhubungan dengan brief pekerjaan bisa didiskusikan menggunakan fitur chat messenger yang kami miliki. Anda juga bisa mengirimkan file tambahan dan juga melakukan permintaan revisi jika diperlukan secara mudah dan aman.                
                            </p>,
                    img: imgTab4
                },
                {
                    title: "Reporting Summary",
                    subTitle: "Dapatkan laporan lengkap semua aktifitas Anda",
                    detail: <p> 
                                Semua data hasil aktifitas yang Anda lakukan di SosiaGo Indonesia akan direkap dan tersimpan di dalam fitur report summary (analytic) kami. Anda dapat meiihat data laporan aktifitas pekerjaan (placement) dan performa hasil dari setiap pekerjaan tersebut. <br /><br />
                                Report data yang kami berikan, disajikan secara lengkap dan mudah dipahami. Anda dapat mengetahui tingkat sukses aktifitas campaign Anda termasuk mengetahui cost effective (impressions based) dari setiap thasil placement yang telah Anda terima untuk evaluasi dikemudian hari.                
                            </p>,
                    img: imgTab5
                }
            ],
            activeTab: "feature1"
        }
        this.handleClick = this.handleClick.bind(this)
    }

    handleClick(e){
        const target = e.target;
        const data = target.dataset
        this.setState({
            activeTab: data.name
        })        
        const tabs = document.getElementsByClassName('tab')
        for(let i = 0; i < tabs.length; i++){
            tabs[i].classList.remove('active')            
        }        
        target.classList.add('active')
    }

    render(){
        const {
            features,
            activeTab
        } = this.state
        const {
            handleClick
        } = this        
        const info = features.map((feature, i) => 
            <div className={`container ${`feature${i+1}` === activeTab ? 'active' : ''}`} key={i+1}>
                <div className="text">
                    <div className="icon">
                        <img src={imgFeature1}/>
                    </div>
                    <h3>{feature.title}</h3>
                    <h5>{feature.subTitle}</h5>
                    {feature.detail}
                    <div className="preview-action"><span>Lihat lebih banyak</span></div>
                </div>
                <div className="dashboard">
                    <img src={feature.img} />                    
                </div>
            </div>
        )
        return(
            <div id="tabtools">
                <div className="tabtools-header">                            
                    <h1>Beberapa fitur menarik di SOSIAGO</h1>
                    <p>Segera bergabung untuk melihat fitur menarik lainnya.</p>
                </div>
                <div className="tablist">
                    <div className="tab active" data-name="feature1" onClick={handleClick} >
                        <img src={imgFeature1}/>
                        <p>Campaign Dashboard</p>
                    </div>
                    <div className="tab" data-name="feature2" onClick={handleClick} >
                        <img src={imgFeature2}/>
                        <p>Task Monitoring</p>
                    </div>
                    <div className="tab" data-name="feature3" onClick={handleClick} >
                        <img src={imgFeature3}/>
                        <p>Channel Filtering</p>
                    </div>
                    <div className="tab" data-name="feature4" onClick={handleClick} >
                        <img src={imgFeature4}/>
                        <p>Brief Discussion</p>
                    </div>
                    <div className="tab" data-name="feature5" onClick={handleClick} >
                        <img src={imgFeature5}/>
                        <p>Reporting Summary</p>
                    </div>
                </div>
                <div className="tabinfo">
                    {info}
                </div>
            </div> 
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Feature.js